import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import { WS_COLOR } from './tokens';

export interface ProgressProps {
  /** What is progressing, e.g. "Importing 1,240 rows". Always visible: bars are not enough. */
  label: string;
  /** 0 to 100. Omit for work of unknown length. */
  value?: number;
}

/** A labelled bar. The percentage is written as well as drawn. */
export function Progress({ label, value }: ProgressProps) {
  const determinate = typeof value === 'number';
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="body2">{label}</Typography>
        {determinate ? (
          <Typography variant="body2" sx={{ color: WS_COLOR.textMuted }}>
            {Math.round(value)}%
          </Typography>
        ) : null}
      </Box>
      <LinearProgress
        aria-label={label}
        variant={determinate ? 'determinate' : 'indeterminate'}
        value={determinate ? value : undefined}
      />
    </Box>
  );
}
